export const Footer = () => {
  return(
    <footer className="footer">
      <img className="footerImg" src={require('./images/jay.png')}  alt="" />
      <div> Hi I am the footer my name is bannana wolf.</div>
      <img className="footerImg" src={require('./images/jay.png')}  alt="bannana wolf" />
      
    </footer>
  ) 
};
